import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

interface ApiClientProps extends AxiosRequestConfig {
  endpoint: string;
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE';
  data?: any;
}

// const BASE_URL = 'https://qawebapi.suffix.events/events/api/v1/';  // replace with your actual base URL

export const apiClientExport = async <T = any>({
  endpoint,
  method = 'GET',
  data,
  responseType,
  ...config
}: ApiClientProps): Promise<AxiosResponse<T>> => {
  const response = await axios<T>({
    // url: `${BASE_URL}${endpoint}`,
    url: endpoint,
    method,
    data,
    responseType, // ✅ supports 'blob'
    headers: {
      'Content-Type': 'application/json',
      ...config.headers,
    },
  });

  return response;
};